import React from 'react';

export type FocusContextOptions = { hasFocus: boolean; focus: () => void; blur: () => void };
export const FocusContext = React.createContext<FocusContextOptions>({
  hasFocus: false,
  focus: () => undefined,
  blur: () => undefined,
});
